<template>
  <div class="module-container">
    <div class="container">
      <div class="content-wrapper">
        <!-- 左侧：传统模式 -->
        <div class="left-section">
          <div class="mode-tag traditional-tag">传统模式：焦虑与局限</div>
          <div class="section-title">以前，你是一个人抗所有</div>
          <ul class="pain-points">
            <li class="pain-point">
              <span class="point-title">苦寻关系</span>
              <span class="point-desc">独自敲门，效率低下，关系难以裂变。</span>
            </li>
            <li class="pain-point">
              <span class="point-title">资源建设全要靠自己</span>
              <span class="point-desc">能做什么生意都要自己建设资源。</span>
            </li>
            <li class="pain-point">
              <span class="point-title">养人维艰</span>
              <span class="point-desc">淡季养人成本过高，旺季人手不足，团队管理心力交瘁。</span>
            </li>
          </ul>
        </div>

        <!-- 右侧：易隆模式 -->
        <div class="right-section">
          <div class="mode-tag elon-tag">易隆创：赋能与爆发</div>
          <div class="section-title gradual">现在，易隆创把这一切拆开</div>
          <div class="section-subtitle">你只需要做你最擅长的商务关系，剩下的，平台替你配齐。</div>
          <div class="solutions-grid">
            <div class="solution-card">
              <div class="solution-title">关系联通</div>
              <div class="solution-desc">我的可以成为我们的</div>
            </div>
            <div class="solution-card">
              <div class="solution-title">供应商资源配齐</div>
              <div class="solution-desc">全行业供应商资源一键获取</div>
            </div>
            <div class="solution-card">
              <div class="solution-title">核心竞争力配齐</div>
              <div class="solution-desc">行业优秀方案支持</div>
            </div>
            <div class="solution-card">
              <div class="solution-title">交付配齐</div>
              <div class="solution-desc">交付能力全产业覆盖，打破能力边界</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
};
</script>

<style lang="less" scoped>
.module-container {
  height: 501px;
  background-image: url('@/assets/img/home/Empowerment/background.png');
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;

  .container {
    max-width: @content-width;
    margin: 0 auto;
    width: 100%;
  }

  .content-wrapper {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
  }

  .left-section,
  .right-section {
    flex: 1;
    max-width: 520px;
  }

  .mode-tag {
    display: inline-block;
    padding: 6px 16px;
    border-radius: 16px;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 20px;

    &.traditional-tag {
      background-color: rgba(255, 255, 255, 0.2);
      color: #fff;
    }

    &.elon-tag {
      padding-left: 36px;
      background-color: #FFEDC5;
      color: #FF7922;
      position: relative;
      &::before {
        content: '';
        width: 16px;
        height: 16px;
        background-image: url('@/assets/img/home/Empowerment/icon_hot.png');
        background-size: 100% 100%;
        position: absolute;
        top: 50%;
        left: 16px;
        transform: translateY(-50%);
      }
    }
  }

  .section-title {
    font-size: 36px;
    font-family: @font-bold;
    margin-bottom: 14px;
    color: #fff;
    &.gradual {
      background: linear-gradient(to bottom, #FFFCE5 20%, #FFE947 100%);
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
      // 文字阴影
      text-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    }
  }

  .section-subtitle {
    font-size: 16px;
    color: rgba(255, 255, 255, 0.9);
    margin-bottom: 28px;
    line-height: 1.5;
  }

  .pain-points {
    list-style: none;
    padding: 0;
    margin: 0;
    padding-top: 10px;

    .pain-point {
      display: block;
      color: #fff;
      margin-bottom: 16px;
      line-height: 1.4;

      .point-title {
        display: block;
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 4px;
        padding-left: 15px;
        position: relative;
        &:before {
          content: '';
          width: 5px;
          height: 5px;
          background-color: #666666;
          border-radius: 50%;
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
        }
      }

      .point-desc {
        margin-top: 10px;
        display: block;
        font-size: 14px;
        opacity: 0.9;
        padding-left: 15px;
      }
    }
  }

  .solutions-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }

  .solution-card {
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 8px;
    padding: 16px 12px;
    transition: all 0.3s ease-in-out;
    &:hover {
      background-color: rgba(255, 255, 255, 0.2);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
    .solution-title {
      font-size: 20px;
      font-weight: 600;
      color: #fff;
      margin-bottom: 4px;
    }

    .solution-desc {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.9);
      line-height: 1.3;
    }
  }
}
</style>
